<template>
  <div>
    <el-dialog
      title="发货联系人"
      :visible.sync="deliverShow"
      :before-close="closeaddPopmo"
      :close-on-click-modal="false"
    >
      <div
        style="
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
        "
      >
        <div>
          <el-input
            clearable
            @clear="getFadata()"
            v-model="nameOrPhoneByFa"
            @keyup.native="searchNameOrPhoneByFa"
            placeholder="请输入姓名或电话"
            size="medium"
            style="width: 250px"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button slot="append" type="primary">搜索</el-button>
          </el-input>
        </div>

        <el-button size="medium" plain type="primary" @click="addNewpop()"
          >新增发货联系人</el-button
        >
      </div>
      <el-table size="mini" border @row-click="rowFaset" :data="FapopList">
        <el-table-column
          property="name"
          label="姓名"
          width="200"
        ></el-table-column>
        <el-table-column property="tel" label="电话"></el-table-column>
        <el-table-column property="tag" label="标签"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click.stop="setAsDefault(scope.row)"
            >
              <span
                :style="scope.row.isdefault ? 'color:#9A9A9A' : 'color:#FF4D01'"
                >{{ scope.row.isdefault ? "默认" : "设为默认" }}</span
              >
            </el-button>
            <el-button @click.stop="UpItem(scope.row)" type="text" size="small"
              >修改</el-button
            >

            <el-button
              @click.stop="confirmDelete(scope.row)"
              type="text"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-alert
        title="点击任意一行选择发货联系人"
        center
        style="margin-top: 20px"
        show-icon
        :closable="false"
      ></el-alert>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog
      class="dialog"
      :width="width"
      :visible.sync="addDeliver"
      @click="addDeliverBtn"
      :closeOnClickModal="false"
      :before-close="addDeliverBtn"
    >
      <div class="wrap_count">
        <div class="fa_logo" style="margin-bottom: 10px">
          {{ !this.itemid ? "新增发货联系人" : "修改发货联系人" }}
        </div>
        <div class="count">
          <el-form
            :rules="fromPopRules"
            :model="fromPop"
            ref="fromPop"
            :label-position="labelPosition"
            label-width="80px"
          >
            <el-form-item label="联系人" prop="name">
              <el-input
                placeholder="请输入姓名"
                v-model="fromPop.name"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="tel">
              <el-input
                placeholder="请输入联系方式"
                v-model="fromPop.tel"
              ></el-input>
            </el-form-item>
            <el-form-item label="标签">
              <el-input
                placeholder="请输入标签"
                v-model="fromPop.tag"
              ></el-input>
            </el-form-item>
            <el-form-item prop="type">
              <el-checkbox-group v-model="fromPop.isdefault">
                <el-checkbox name="type">设置为默认地址</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit('fromPop')">{{
                itemid ? "修改" : "确定新增"
              }}</el-button>
              <el-button @click="addDeliverBtn">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    deliverShow: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      labelPosition: "left",
      FapopList: [],
      itemid: "",
      urbanAreas: [],
      width: "420px",
      addDeliver: false,
      fromPop: {
        parvince: "",
        city: "",
        area: "",
        country: "",
        customerid: null,
        id: "",
        isdefault: false,
        name: "",
        tag: "",
        tel: "",
      },
      nameOrPhoneByFa: "",
      tempTableDataByFa: [],
      fromPopRules: {
        name: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        tel: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
      },
    };
  },
  
  watch: {},
  methods: {
    addDeliverBtn(){
      this.addDeliver=false;
      this.$refs.fromPop.clearValidate();
    },
    rowFaset(e) {
      this.$emit("closeDeliver");
      this.$emit("setDeliver", e);
    },
    addNewpop() {
      this.addDeliver = true;
      this.itemid = "";
      this.fromPop.name = "";
      this.fromPop.tel = "";
      this.fromPop.tag = "";
      this.urbanAreas = [];
      this.fromPop.address = "";
      this.fromPop.isdefault=false;
    },
    // 模糊搜索
    searchNameOrPhoneByFa() {
      if (!this.nameOrPhoneByFa) {
        return this.getFadata();
      }
      let temp = [];
      this.tempTableDataByFa.forEach((item, index) => {
        if (
          item.name.indexOf(this.nameOrPhoneByFa) != -1 ||
          item.tel.indexOf(this.nameOrPhoneByFa) != -1
        ) {
          temp.push(item);
        }
      });
      this.FapopList = temp;
    },
    //删除发货联系人
    confirmDelete(item) {
      this.$confirm("此操作将删除该发货联系人, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let user = this.sessionGetUserInfo();
          this.axios
            .post(
              "/customer/delAddress/" + item.id,
              {},
              {
                headers: {
                  token: user.token,
                },
              }
            )
            .then((res) => {
              if (res.data.code != 200) {
                this.$message("服务器繁忙");
                return;
              }
              this.$message("删除成功");
              this.getFadata();
            })
            .catch((res) => {
              this.$message("服务器繁忙");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getFadata() {
      //发货人
      let that = this;
      let customerId = this.sessionGetUserInfo().customerid;
      this.axios
        .get(`/customer/addressListForShipper/${customerId}`)
        .then((res) => {
          if (res.data.code == "200") {
            this.FapopList = res.data.datas;
            this.tempTableDataByFa = res.data.datas;
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    UpItem(item) {
      //修改发货
      this.itemid = item.id;
      this.urbanAreas = [];
      this.addDeliver = true;
      this.fromPop = JSON.parse(JSON.stringify(item));
      this.$refs.fromPop.clearValidate();
    },
    isPhone(num) {
      let mPattern = /^1[345678]\d{9}$/;
      return mPattern.test(num);
    },

    // 发货地址设为默认
    setAsDefault(item) {
      if (item.isdefault) {
        return this.$message.info("已经是默认地址");
      }
      this.axios
        .post(`/api/customer/updateAddressDefault?addressId=${item.id}`, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.getFadata();
            this.$message.success("设置成功！");
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {});
    },
    onSubmit(formName) {
      //新增发货
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.isPhone(this.fromPop.tel))
            return this.$message({ message: "请输入正确的手机号码" });
          let params = {
            customerid: this.sessionGetUserInfo()
              .customerid, //客户id
            id: this.itemid,
            isdefault: this.fromPop.isdefault,
            name: this.fromPop.name,
            tag: this.fromPop.tag,
            tel: this.fromPop.tel,
          };
          this.axios
            .post(`/customer/addOrUpdateShipper`, params)
            .then((res) => {
              // console.log(res);
              if (res.data.code == "200") {
                this.$message({ message: "成功", type: "success" });
                this.addDeliver = false;
                this.getFadata();
              } else {
                this.$message(res.data.message);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeaddPopmo() {
      this.$emit("closeaddPopmo", false);
    },
  },
  created() {},
  mounted() {
    this.getFadata();
  },
};
</script>
<style scoped>
.fa_logo {
  font-size: 16px;
  margin-top: -20px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/privateOrder/components/deliverGoods.vue